import { useUnsavedChangesWarning } from "@/hooks/use-unsaved-changes-warning";
import { useRealTimeUpdates } from "@/hooks/useRealTimeUpdates";
import { useUIStore } from "@/shared/stores/ui-store";
import { ActivityLog } from "@/widgets/activity-log/ui/ActivityLog";
import { UniversalSearch } from "@/widgets/search/ui/UniversalSearch";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export function AppLayout() {
  const { showActivityLog, setShowActivityLog } = useUIStore();
  useRealTimeUpdates();
  useUnsavedChangesWarning();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        showActivityLog={showActivityLog}
        onToggleActivityLog={() => setShowActivityLog(!showActivityLog)}
      />

      <div className="flex h-[calc(100vh-64px)]">
        <Sidebar />

        <PanelGroup direction="horizontal" className="flex-1">
          <Panel defaultSize={showActivityLog ? 75 : 100} minSize={50} id="main-panel">
            <main className="h-full overflow-auto">
              <div className="container mx-auto p-6">
                <div className="mb-6">
                  <UniversalSearch />
                </div>
                <Outlet />
              </div>
            </main>
          </Panel>
          {showActivityLog && (
            <>
              <PanelResizeHandle className="w-2 bg-border transition-colors hover:bg-border/80" />
              <Panel defaultSize={25} minSize={20} maxSize={50} id="activity-log-panel">
                <div className="h-full border-l">
                  <ActivityLog onClose={() => setShowActivityLog(false)} />
                </div>
              </Panel>
            </>
          )}
        </PanelGroup>
      </div>
    </div>
  );
}
